@app.directive 'ssoForm', (ssoService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @visibleForm = 'signup'
    if (ssoService.isZendesk() || ssoService.isFBMessenger())
      @visibleForm = 'login'

    @login = =>
      @visibleForm = 'login'

    @signup = =>
      @visibleForm = 'signup'
    this

  controllerAs: 'ssoForm'
  templateUrl: "/assets/templates/directives/ssoForm/ssoForm.html"
